import React from 'react';
import { XCircle } from '@phosphor-icons/react';

import { StatusShell } from '../../design-system/components/shells';
import {
  StatusAction,
  StatusReason,
  StatusRedirect,
} from '../../design-system/patterns/status';
import { routes } from '../../routes/routes';

/**
 * Payment failed, the view. Pure: every input is a prop, every output a
 * callback.
 *
 * The container (`PaymentFailed.jsx`) clears the order lock, fires the analytics
 * event and owns the redirect timer.
 *
 * A FAILURE SPLASH HAS ONE JOB: kill the panic, then hand back the controls.
 * So the reassurance comes BEFORE the reason, because "did it take my money" is
 * the question the user is actually asking, and the reason is the answer to a
 * question they have not got to yet.
 *
 * The primary command is "Back to cart", not "Try again". The cart IS the retry
 * on this app: checkout is entered from there and the cart is untouched by a
 * failed payment. A "Try again" button that cannot re-open the same gateway
 * session would be a control that does not do what it says.
 *
 * The button stays INK. A red "Try again" would read as a destructive command,
 * and the disc is already carrying the outcome.
 */

/** What we can honestly say without a reason code from the gateway. */
const DEFAULT_REASON =
  'The payment was not completed at the gateway. If your bank turned it down it is usually a daily limit or a block on online purchases, which is worth checking before you retry.';

export function PaymentFailedView({ reason = DEFAULT_REASON, redirectIn = null }) {
  return (
    <StatusShell
      tone="error"
      icon={XCircle}
      title="Payment did not go through"
      description="No money has left your account and your cart is exactly as you left it."
      actions={
        <>
          <StatusAction to="/cart">Back to cart</StatusAction>
          <StatusAction to={routes.DASHBOARD} variant="ghost">
            Go to your dashboard
          </StatusAction>
          <StatusRedirect seconds={redirectIn} destination="your dashboard" />
        </>
      }
    >
      <StatusReason>{reason}</StatusReason>
    </StatusShell>
  );
}

export default PaymentFailedView;
